import { useEffect, useState } from 'react';

// Debounced search input. Calls onSearch(value) 350ms after typing stops.
export default function SearchBar({ value, onSearch, placeholder = 'Search…' }) {
  const [local, setLocal] = useState(value || '');
  useEffect(() => {
    const t = setTimeout(() => onSearch(local.trim()), 350);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [local]);
  return (
    <input
      className="search-bar"
      type="search"
      value={local}
      placeholder={placeholder}
      onChange={(e) => setLocal(e.target.value)}
    />
  );
}
